module.exports = __webpack_public_path__ + "static/media/Photo4.b9190676.jpg";